import {
  getActiveLeaveTypes as getActiveLeaveTypesService,
  applyLeave as applyLeaveService,
  cancelLeave as cancelLeaveService,
  getLeaveSummary as getLeaveSummaryService,
  getMyLeaves as getMyLeavesService,
} from "services/company/leaveManagement/applyLeave/applyLeaveService";
import {
  getLeaveTypesStart,
  getLeaveTypesSuccess,
  getLeaveTypesFailure,
  getLeaveSummaryStart,
  getLeaveSummarySuccess,
  getLeaveSummaryFailure,
  getMyLeavesStart,
  getMyLeavesSuccess,
  getMyLeavesFailure,
  applyLeaveStart,
  applyLeaveSuccess,
  applyLeaveFailure,
  cancelLeaveStart,
  cancelLeaveSuccess,
  cancelLeaveFailure,
} from "./applyLeaveSlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch leave summary & balances
export const fetchLeaveSummary = () => async (dispatch) => {
  try {
    dispatch(getLeaveSummaryStart());
    const response = await getLeaveSummaryService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getLeaveSummarySuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch leave summary";
      dispatch(getLeaveSummaryFailure(errorMsg));
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch leave summary error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch leave summary";
    dispatch(getLeaveSummaryFailure(errorMsg));
    return { success: false, error: errorMsg };
  }
};

// Fetch my submitted leave requests
export const fetchMyLeaves = (params) => async (dispatch) => {
  try {
    dispatch(getMyLeavesStart());
    const response = await getMyLeavesService(params);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getMyLeavesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch leave requests";
      dispatch(getMyLeavesFailure(errorMsg));
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch my leaves error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch leave requests";
    dispatch(getMyLeavesFailure(errorMsg));
    return { success: false, error: errorMsg };
  }
};

// Fetch active leave types
export const fetchLeaveTypes = () => async (dispatch) => {
  try {
    dispatch(getLeaveTypesStart());
    const response = await getActiveLeaveTypesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getLeaveTypesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch leave types";
      dispatch(getLeaveTypesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch leave types error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch leave types";
    dispatch(getLeaveTypesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Apply for leave
export const applyForLeave = (leaveData) => async (dispatch) => {
  try {
    dispatch(applyLeaveStart());
    const response = await applyLeaveService(leaveData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(applyLeaveSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Leave applied successfully!"
      );
      // Refresh leave summary/balances and my leaves automatically
      dispatch(fetchLeaveSummary());
      dispatch(fetchMyLeaves());
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to apply leave";
      dispatch(applyLeaveFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Apply leave error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to apply leave";
    dispatch(applyLeaveFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Cancel leave
export const cancelExistingLeave = (leaveId) => async (dispatch) => {
  try {
    dispatch(cancelLeaveStart());
    const response = await cancelLeaveService(leaveId);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(cancelLeaveSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Leave cancelled successfully!"
      );
      dispatch(fetchLeaveSummary());
      dispatch(fetchMyLeaves());
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to cancel leave";
      dispatch(cancelLeaveFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Cancel leave error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to cancel leave";
    dispatch(cancelLeaveFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};